(function () {
  var banner = document.getElementById('CookieConsentBanner');
  var overlay = document.getElementById('CookieConsentOverlay');

  if (!banner || !overlay || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    return;
  }

  function hasVisitorChoice(customerPrivacy) {
    if (!customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function') {
      return false;
    }

    var consent = customerPrivacy.currentVisitorConsent();
    return ['analytics', 'marketing', 'preferences'].some(function (purpose) {
      return consent[purpose] === 'yes' || consent[purpose] === 'no';
    });
  }

  function hideBanner() {
    banner.hidden = true;
    overlay.hidden = true;
    document.documentElement.classList.remove('cookie-consent-is-blocked');
  }

  function showBanner() {
    banner.hidden = false;
    overlay.hidden = false;
    document.documentElement.classList.add('cookie-consent-is-blocked');
  }

  function showBannerIfNeeded() {
    var customerPrivacy = window.Shopify.customerPrivacy;

    if (!customerPrivacy) {
      return;
    }

    if (!hasVisitorChoice(customerPrivacy)) {
      showBanner();
    }
  }

  function setConsent(value) {
    var customerPrivacy = window.Shopify.customerPrivacy;

    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
      hideBanner();
      return;
    }

    customerPrivacy.setTrackingConsent({
      analytics: value,
      marketing: value,
      preferences: value
    }, hideBanner);
  }

  window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1'
    }
  ], function (error) {
    if (error) {
      return;
    }

    showBannerIfNeeded();
  });

  banner.querySelector('[data-cookie-consent-accept]').addEventListener('click', function () {
    setConsent(true);
  });

  banner.querySelector('[data-cookie-consent-reject]').addEventListener('click', function () {
    setConsent(false);
  });
})();
